<template>
  <!-- Dialogo para indicar errores -->
  <v-dialog
    v-model="exiparams.estatus"
    persistent
    max-width="400"
  >
    <v-card>
    	<v-card-title primary-title>
				<v-spacer></v-spacer>
			  <span class="text-body-1 text-center">Registro</span>
				<v-spacer></v-spacer>
			</v-card-title>

      <v-card-text class="pt-8">
      	<v-form
			    ref="form"
			    v-model="valid"
			    lazy-validation
			  >
	        <v-text-field
	          outlined
	          rounded
	          label="Nombres"
	          v-model="exiparams.nombre"
	          append-icon="mdi-account"
      			:rules="nameRules"
	        ></v-text-field>

	        <v-text-field
	          outlined
	          rounded
	          label="Apellidos"
	          v-model="exiparams.apellidos"
	          append-icon="mdi-account"
      			:rules="nameRules"
	        ></v-text-field>

	        <v-text-field
	          outlined
	          rounded
	          label="Teléfono"
	          v-model="exiparams.telefono"
	          append-icon="mdi-phone"
      			:rules="nameRules"
      			type="number"
	        ></v-text-field>

	        <v-text-field
	          outlined
	          rounded
	          label="Correo"
	          v-model="exiparams.correo"
	          append-icon="mdi-mail"
	          :rules="emailRules"
			      required
	        ></v-text-field>

	        <!-- <v-select
	          :items="['APODACA','NORIA','ROMULO GARZA','LINDA VISTA','ELOY','UNIVERSIDAD']"
	          label="Sucursal"
	          :rules="nameRules"
	          v-model="exiparams.sucursal"
	          append-icon="mdi-school"
	          outlined
	          rounded
	        ></v-select>

	        <v-select
	          :items="['Lunes a Viernes','Sabatino matutino','Dominical matutino']"
	          outlined
	          rounded
	          label="Horario"
	          v-model="exiparams.horario"
	          append-icon="mdi-calendar"
	          :rules="nameRules"
	        ></v-select> -->

	        <!-- <v-text-field
	          outlined
	          rounded
	          label="¿Conoces tu codigo?"
	          v-model="exiparams.codigo"
	          append-icon="mdi-barcode"
	        ></v-text-field> -->
	      </v-form>

      </v-card-text>
      <v-card-actions>
        <v-btn
          block
          dark
          color="blue"
          rounded
          @click="validate()"
        >
          Registrarme
        </v-btn>
      </v-card-actions>

      <v-speed-dial
        top
        right
        absolute
        class="mb-4 me-n4 mt-n4"
      >
        <template v-slot:activator>
          <v-btn
            icon
            fab
            small
            @click="exiparams.estatus = false"
          >
            <v-icon>
              mdi-close
            </v-icon>
          </v-btn>
        </template>
      </v-speed-dial>
    </v-card>
  </v-dialog>
</template>


<script>
	// Importar lebrerías
	import { mapGetters, mapActions } from 'vuex'

	export default {
		data: () => ({
			valid: true,
			 nameRules: [
        v => !!v || 'Requerido',
      ],
			emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
		}),

		props:['exiparams'],

    computed:{
      ...mapGetters( 'login', [ 'getGrupo', 'getUsuarioLMS', 'getRecursosGrupoUsuario', 'getGrupos', 'getEscuela' ]),
    },

    methods:{

    	validate () {
        if(this.$refs.form.validate()){
        	this.$emit('click')
        }
      },

    }
  }
</script>

